import { select } from '@ps/web-core-store';
import { Translation } from '@ps/web-shared-components';
import classNames from 'clsx';
import React from 'react';
import { useSelector } from 'react-redux';

import { useOnboardingContext } from '@swf/components/Onboarding/OnboardingContext/OnbordingContext';

import LogoSpinner from '../../assets/logo-spingo-spinner.svg';
import gameData from '../../constants/gameData';
import { OnboardingStep } from '../../types/';
import type { GameTypeName } from '../../types/Game';

import PlayNowButton from './PlayNowButton';
import { TXTCLI_How_it_worksX } from './Sidebar.messages.json';
import styles from './Sidebar.scss';

export interface Props {
  gameType: GameTypeName;
  onHowToPlayClick?: () => void;
  onRegisterOpen: () => void;
  showPlayButton: boolean;
}

const Sidebar: React.FC<Props> = ({
  gameType,
  onHowToPlayClick,
  onRegisterOpen,
  showPlayButton
}) => {
  const { translation, icon } = gameData[gameType];
  const { setFlowToStep, activeStep, onboardingFinished } = useOnboardingContext();
  const isDesktopEmbedded = useSelector(select.device.isDesktopEmbedded);

  return (
    <div
      className={classNames(
        isDesktopEmbedded ? styles.embeddedSidebar : styles.sidebar,
        styles[`sideBar${gameType}`]
      )}
      key={gameType}
    >
      <div className={styles.logoCover}>
        <div className={styles.logoContainer}>
          {icon}
          <LogoSpinner className={styles.spinner} />
        </div>
      </div>
      <div
        className={classNames(styles.content, {
          [styles.onboardingFocus]: !onboardingFinished && activeStep === OnboardingStep.HowToPlay
        })}
      >
        <p>
          <Translation tagName="span" {...translation} />{' '}
          <span
            className={styles.linkText}
            onClick={onHowToPlayClick}
            ref={
              !onboardingFinished && setFlowToStep ? setFlowToStep(OnboardingStep.HowToPlay) : null
            }
          >
            <Translation {...TXTCLI_How_it_worksX} />
          </span>
        </p>
      </div>
      {showPlayButton && <PlayNowButton onClick={onRegisterOpen} />}
    </div>
  );
};

export default Sidebar;
